export default "__VITE_ASSET__DzRSOuzR__"